"use strict";

var _regeneratorRuntime = require("/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Eth = void 0;

var constants_1 = require("../eth/constants");

var methods_1 = require("../communication/methods");

var inputFormatters = {
  defaultBlockParam: function defaultBlockParam() {
    var arg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'latest';
    return arg;
  },
  returnFullTxObjectParam: function returnFullTxObjectParam() {
    var arg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return arg;
  },
  blockNumberToHex: function blockNumberToHex(arg) {
    return Number.isInteger(arg) ? "0x".concat(arg.toString(16)) : arg;
  }
};

var Eth = /*#__PURE__*/function () {
  function Eth(communicator) {
    var _this = this;

    _classCallCheck(this, Eth);

    this.communicator = communicator;
    this.call = this.buildRequest({
      call: constants_1.RPC_CALLS.eth_call,
      formatters: [null, inputFormatters.defaultBlockParam]
    });
    this.getBalance = this.buildRequest({
      call: constants_1.RPC_CALLS.eth_getBalance,
      formatters: [null, inputFormatters.defaultBlockParam]
    });
    this.getCode = this.buildRequest({
      call: constants_1.RPC_CALLS.eth_getCode,
      formatters: [null, inputFormatters.defaultBlockParam]
    });
    this.getStorageAt = this.buildRequest({
      call: constants_1.RPC_CALLS.eth_getStorageAt,
      formatters: [null, inputFormatters.blockNumberToHex, inputFormatters.defaultBlockParam]
    });
    this.getPastLogs = this.buildRequest({
      call: constants_1.RPC_CALLS.eth_getLogs
    });
    this.getBlockByHash = this.buildRequest({
      call: constants_1.RPC_CALLS.eth_getBlockByHash,
      formatters: [null, inputFormatters.returnFullTxObjectParam]
    });
    this.getBlockByNumber = this.buildRequest({
      call: constants_1.RPC_CALLS.eth_getBlockByNumber,
      formatters: [inputFormatters.blockNumberToHex, inputFormatters.returnFullTxObjectParam]
    });
    this.getTransactionByHash = this.buildRequest({
      call: constants_1.RPC_CALLS.eth_getTransactionByHash
    });
    this.getTransactionReceipt = this.buildRequest({
      call: constants_1.RPC_CALLS.eth_getTransactionReceipt
    });
    this.getTransactionCount = this.buildRequest({
      call: constants_1.RPC_CALLS.eth_getTransactionCount,
      formatters: [null, inputFormatters.defaultBlockParam]
    });
    this.getGasPrice = this.buildRequest({
      call: constants_1.RPC_CALLS.eth_gasPrice
    });

    this.getEstimateGas = function (transaction) {
      return _this.buildRequest({
        call: constants_1.RPC_CALLS.eth_estimateGas
      })([transaction]);
    };
  }

  _createClass(Eth, [{
    key: "buildRequest",
    value: function buildRequest(args) {
      var _this2 = this;

      var call = args.call,
          formatters = args.formatters;
      return /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
          var payload, response;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (formatters && Array.isArray(params)) {
                    formatters.forEach(function (formatter, i) {
                      if (formatter) {
                        params[i] = formatter(params[i]);
                      }
                    });
                  }

                  payload = {
                    call: call,
                    params: params || []
                  };
                  _context.next = 4;
                  return _this2.communicator.send(methods_1.Methods.rpcCall, payload);

                case 4:
                  response = _context.sent;
                  return _context.abrupt("return", response.data);

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
    }
  }]);

  return Eth;
}();

exports.Eth = Eth;